import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { NavList } from "./Nav";

const LOGO = "https://static.prod-images.emergentagent.com/jobs/c02bbf84-8886-4377-905b-679db2c42392/images/5c039c6f074720e3012a5ef07213bb317697ebfacf88fb25975233abab81445e.png";

export function Brand({ compact }) {
  return (
    <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
      <img src={LOGO} alt="TL-Thunderbird" className="h-9 w-9 rounded-lg object-cover" />
      {!compact && (
        <div className="leading-tight">
          <p className="font-heading text-lg font-extrabold tracking-tight text-brand-ink">TL-Thunderbird</p>
          <p className="text-[0.65rem] font-semibold uppercase tracking-[0.16em] text-brand-mute">
            Campaign Ops
          </p>
        </div>
      )}
    </Link>
  );
}

export function Sidebar() {
  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: () => api.get("/settings/profile").then((r) => r.data),
    staleTime: 60000,
  });
  return (
    <aside className="fixed inset-y-0 left-0 z-30 hidden w-[260px] flex-col border-r border-border bg-white lg:flex">
      <div className="flex h-16 items-center border-b border-border px-5">
        <Brand />
      </div>
      <div className="flex-1 overflow-y-auto py-6">
        <NavList />
      </div>
      <div className="border-t border-border p-4">
        <div className="rounded-lg bg-brand-navy/[0.04] p-3">
          <p className="text-xs font-semibold text-brand-navy" data-testid="sidebar-jurisdiction">
            {profile?.jurisdiction || "Michigan"}
          </p>
          <p className="mt-0.5 text-[0.7rem] text-brand-mute">2026 cycle · single-org workspace</p>
        </div>
      </div>
    </aside>
  );
}
